var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 5.33333C10.3334 6.622 9.28875 7.66667 8.00008 7.66667C6.71142 7.66667 5.66675 6.622 5.66675 5.33333C5.66675 4.04467 6.71142 3 8.00008 3C9.28875 3 10.3334 4.04467 10.3334 5.33333Z",
    strokeWidth: 1.13333,
    stroke: "#85869A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19995 13.3302C3.59995 10.9969 5.33328 9.79688 7.99995 9.79688C10.6666 9.79688 12.4 10.9969 12.8 13.3302",
    strokeWidth: 1.13333,
    strokeLinecap: "round",
    stroke: "#85869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUserIcon);
export default __webpack_public_path__ + "static/media/notification-user-icon.5e3f1527ce6ccbe3aae232596ee028e7.svg";
export { ForwardRef as ReactComponent };